import { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { turnosService, diasBloqueadosService, serviciosService } from "../../services/api";
import { CATEGORIAS_RESERVA, agruparServiciosPorNombre, nombreCompletoServicio, etiquetaVariante } from "../../config/servicios";
import { enviarEmailConfirmacion } from "../../config/EmailService";
import CheckAnimado from "../Animaciones/CheckAnimado";
import "./Reservas.css";

function Reservas() {
  const [paso, setPaso] = useState(1);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("");
  const [nombreServicioSeleccionado, setNombreServicioSeleccionado] = useState("");
  const [varianteSeleccionada, setVarianteSeleccionada] = useState(null);
  const [fechaSeleccionada, setFechaSeleccionada] = useState("");
  const [horaSeleccionada, setHoraSeleccionada] = useState("");
  const [horasDisponibles, setHorasDisponibles] = useState([]);
  const [notas, setNotas] = useState("");
  const [cargando, setCargando] = useState(false);
  const [exito, setExito] = useState(false);
  const [errorFecha, setErrorFecha] = useState("");
  const [diasBloqueados, setDiasBloqueados] = useState([]);
  const [catalogo, setCatalogo] = useState([]);
  const navigate = useNavigate();

  const _nombre = localStorage.getItem("nombre");

  const _grupoServicios = agruparServiciosPorNombre(catalogo, categoriaSeleccionada);
  const _grupoSeleccionado = _grupoServicios.find((g) => g.nombre === nombreServicioSeleccionado);
  const _variantesDelNombre = _grupoSeleccionado ? _grupoSeleccionado.variantes : [];
  const _necesitaVariante = _variantesDelNombre.length > 1;
  const _pasos = _necesitaVariante
    ? ["categoria", "servicio", "variante", "fecha", "confirmacion"]
    : ["categoria", "servicio", "fecha", "confirmacion"];
  const _pasoActual = _pasos[paso - 1];

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    diasBloqueadosService.obtenerTodos()
      .then((respuesta) => setDiasBloqueados(respuesta.data))
      .catch(() => setDiasBloqueados([]));
    serviciosService.obtenerTodos()
      .then((respuesta) => setCatalogo(respuesta.data))
      .catch(() => setCatalogo([]));
  }, []);

  const elegirCategoria = (categoriaId) => {
    setCategoriaSeleccionada(categoriaId);
    setNombreServicioSeleccionado("");
    setVarianteSeleccionada(null);
    setPaso(2);
  };

  const elegirServicio = (nombre) => {
    setNombreServicioSeleccionado(nombre);
    const _grupo = _grupoServicios.find((g) => g.nombre === nombre);
    const _variantes = _grupo ? _grupo.variantes : [];
    setVarianteSeleccionada(_variantes.length === 1 ? _variantes[0] : null);
  };

  const _esSabado = fechaSeleccionada ? new Date(fechaSeleccionada + "T00:00:00").getDay() === 6 : false;
  const _horasConAnticipacion = fechaSeleccionada
    ? horasDisponibles.filter(
        (hora) => new Date(`${fechaSeleccionada}T${hora}:00`).getTime() - Date.now() >= 24 * 60 * 60 * 1000
      )
    : [];
  const _hayHorasMuyCercanas = !_esSabado && horasDisponibles.length > 0 && _horasConAnticipacion.length < horasDisponibles.length;
  const _requiereCoordinarPorWhatsapp =
    fechaSeleccionada && (_esSabado || (horasDisponibles.length > 0 && _horasConAnticipacion.length === 0));

  useEffect(() => {
    if (fechaSeleccionada && varianteSeleccionada && !_esSabado) {
      obtenerHorasDisponibles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fechaSeleccionada, varianteSeleccionada]);

  const obtenerHorasDisponibles = async () => {
    try {
      const respuesta = await turnosService.obtenerDisponibles(
        fechaSeleccionada,
        nombreCompletoServicio(varianteSeleccionada)
      );
      setHorasDisponibles(respuesta.data);
    } catch (error) {
      console.error("Error al obtener horas disponibles", error);
    }
  };

  const manejarCambioFecha = (e) => {
    const _valor = e.target.value;
    const _fechaElegida = new Date(_valor + "T00:00:00");
    const _diaSemana = _fechaElegida.getDay();

    if (_diaSemana === 0) {
      setErrorFecha("Los domingos el estudio esta cerrado. Elegi otro dia.");
      setFechaSeleccionada("");
      setHoraSeleccionada("");
      return;
    }

    const _estaBloqueado = diasBloqueados.some((d) => d.fecha.slice(0, 10) === _valor);
    if (_estaBloqueado) {
      setErrorFecha("Ese dia el estudio esta cerrado. Elegi otra fecha.");
      setFechaSeleccionada("");
      setHoraSeleccionada("");
      return;
    }

    setErrorFecha("");
    setFechaSeleccionada(_valor);
    setHoraSeleccionada("");
  };

  const confirmarReserva = async () => {
    setCargando(true);

    try {
      const _nombreServicio = nombreCompletoServicio(varianteSeleccionada);
      const _fechaHora = new Date(`${fechaSeleccionada}T${horaSeleccionada}:00`);

      await turnosService.crearTurno({
        servicio: _nombreServicio,
        fechaHora: _fechaHora.toISOString(),
        notas: notas,
        precio: varianteSeleccionada.precio,
        duracionMinutos: 60,
      });

      const _email = localStorage.getItem("email");
      await enviarEmailConfirmacion({
        nombre: _nombre,
        email: _email,
        servicio: _nombreServicio,
        fecha: fechaSeleccionada,
        hora: horaSeleccionada,
        precio: varianteSeleccionada.precio,
      });

      setExito(true);
    } catch (error) {
      alert("Error al crear el turno. Intenta de nuevo.");
    } finally {
      setCargando(false);
    }
  };

  const obtenerFechaMinima = () => {
    return new Date().toISOString().split("T")[0];
  };

  const formatearFechaLegible = (fecha) => {
    const _fecha = new Date(fecha + "T00:00:00");
    return _fecha.toLocaleDateString("es-UY", { weekday: "long", day: "2-digit", month: "2-digit" });
  };

  const abrirWhatsAppTurnoEspecial = () => {
    const _servicio = varianteSeleccionada ? nombreCompletoServicio(varianteSeleccionada) : nombreServicioSeleccionado;
    const _mensaje = `Hola Cata! Soy ${_nombre || "una clienta"}. Quiero coordinar un turno de ${_servicio} para el ${formatearFechaLegible(fechaSeleccionada)}, fuera del horario habitual. ¿Me contás cómo seguimos?`;
    const _url = `https://wa.me/598099481951?text=${encodeURIComponent(_mensaje)}`;
    window.open(_url, "_blank");
  };

  if (exito) {
    return (
      <div className="reservas-pagina">
        <div className="reservas-exito">
          <CheckAnimado />
          <h2>Turno reservado!</h2>
          <p>Te esperamos el {fechaSeleccionada} a las {horaSeleccionada}.</p>
          <p className="exito-sub">Recibiras una confirmacion pronto.</p>
          <div className="exito-botones">
            <button className="btn-principal" onClick={() => navigate("/mis-turnos")}>
              Ver mis turnos
            </button>
            <button className="btn-secundario" onClick={() => navigate("/")}>
              Volver al inicio
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="reservas-pagina">
      <div className="reservas-contenedor">
        <div className="reservas-header">
          <div className="reservas-logo" onClick={() => navigate("/")}>
            <span className="logo-principal">Glowroom</span>
            <span className="logo-secundario">MVD</span>
          </div>
          <p className="reservas-bienvenida">Hola, {_nombre}</p>
        </div>

        <div className="reservas-progreso">
          {_pasos.map((_clave, _indice) => (
            <Fragment key={_clave}>
              {_indice > 0 && <div className="progreso-linea"></div>}
              <div className={`progreso-paso ${paso >= _indice + 1 ? "activo" : ""}`}>
                <span className="paso-numero">{_indice + 1}</span>
                <span className="paso-label">
                  {_clave === "categoria" && "Tipo"}
                  {_clave === "servicio" && "Servicio"}
                  {_clave === "variante" && "Detalle"}
                  {_clave === "fecha" && "Fecha y hora"}
                  {_clave === "confirmacion" && "Confirmación"}
                </span>
              </div>
            </Fragment>
          ))}
        </div>

        {_pasoActual === "categoria" && (
          <div className="reservas-paso">
            <h2 className="paso-titulo">Qué tipo de servicio querés?</h2>
            <div className="categorias-grid-reserva">
              {CATEGORIAS_RESERVA.map((categoria) => (
                <div
                  key={categoria.id}
                  className={`categoria-card-reserva ${categoriaSeleccionada === categoria.id ? "seleccionado" : ""}`}
                  onClick={() => elegirCategoria(categoria.id)}
                >
                  <h3>{categoria.nombre}</h3>
                </div>
              ))}
            </div>
          </div>
        )}

        {_pasoActual === "servicio" && (
          <div className="reservas-paso">
            <h2 className="paso-titulo">Qué servicio querés?</h2>
            <div className="servicios-grid-reserva">
              {_grupoServicios.length === 0 ? (
                <p className="sin-horas">No hay servicios cargados en esta categoría todavía.</p>
              ) : (
                _grupoServicios.map((grupo) => (
                  <div
                    key={grupo.nombre}
                    className={`servicio-card-reserva ${nombreServicioSeleccionado === grupo.nombre ? "seleccionado" : ""}`}
                    onClick={() => elegirServicio(grupo.nombre)}
                  >
                    <h3>{grupo.nombre}</h3>
                    <div className="servicio-info-reserva">
                      <span>{grupo.variantes.length > 1 ? "Varias opciones" : ""}</span>
                      <span className="servicio-precio">
                        {grupo.variantes.length > 1 ? "desde " : ""}${Math.min(...grupo.variantes.map((v) => v.precio))}
                      </span>
                    </div>
                  </div>
                ))
              )}
            </div>
            <div className="reserva-navegacion">
              <button className="btn-secundario" onClick={() => setPaso(paso - 1)}>
                ← Atrás
              </button>
              <button
                className="btn-principal"
                disabled={!nombreServicioSeleccionado}
                onClick={() => setPaso(paso + 1)}
              >
                Siguiente →
              </button>
            </div>
          </div>
        )}

        {_pasoActual === "variante" && (
          <div className="reservas-paso">
            <h2 className="paso-titulo">Elegí el detalle</h2>
            <div className="servicios-grid-reserva">
              {_variantesDelNombre.map((variante) => (
                <div
                  key={variante.id}
                  className={`servicio-card-reserva ${varianteSeleccionada?.id === variante.id ? "seleccionado" : ""}`}
                  onClick={() => setVarianteSeleccionada(variante)}
                >
                  <h3>{etiquetaVariante(variante, nombreServicioSeleccionado)}</h3>
                  <div className="servicio-info-reserva">
                    <span className="servicio-precio">${variante.precio}</span>
                  </div>
                </div>
              ))}
            </div>
            <div className="reserva-navegacion">
              <button className="btn-secundario" onClick={() => setPaso(paso - 1)}>
                ← Atrás
              </button>
              <button
                className="btn-principal"
                disabled={!varianteSeleccionada}
                onClick={() => setPaso(paso + 1)}
              >
                Siguiente →
              </button>
            </div>
          </div>
        )}

        {_pasoActual === "fecha" && (
          <div className="reservas-paso">
            <h2 className="paso-titulo">Elegi fecha y hora</h2>

            <div className="fecha-selector">
              <label className="formulario-label">Fecha</label>
              <input
                type="date"
                className="formulario-input"
                min={obtenerFechaMinima()}
                value={fechaSeleccionada}
                onChange={manejarCambioFecha}
              />
              <p className="fecha-aviso">Atendemos de lunes a viernes de 9:00 a 19:00 hs.</p>
              {errorFecha && <p className="fecha-error">{errorFecha}</p>}
            </div>

            {fechaSeleccionada && (
              _requiereCoordinarPorWhatsapp ? (
                <div className="aviso-turno-especial">
                  <p>
                    {_esSabado
                      ? "Los sábados coordinamos los turnos por WhatsApp: contanos el servicio y el horario que buscás y te confirmamos disponibilidad (este horario especial tiene un costo adicional)."
                      : "Para turnos con menos de 24 horas de anticipación coordinamos por WhatsApp para confirmar que tengamos lugar (este horario especial tiene un costo adicional)."}
                  </p>
                  <button type="button" className="btn-principal" onClick={abrirWhatsAppTurnoEspecial}>
                    Coordinar por WhatsApp
                  </button>
                </div>
              ) : (
                <div className="horas-contenedor">
                  <label className="formulario-label">Horario disponible</label>
                  {horasDisponibles.length === 0 ? (
                    <p className="sin-horas">No hay horarios disponibles para ese dia</p>
                  ) : (
                    <div className="horas-grid">
                      {_horasConAnticipacion.map((hora) => (
                        <button
                          key={hora}
                          className={`hora-btn ${horaSeleccionada === hora ? "seleccionada" : ""}`}
                          onClick={() => setHoraSeleccionada(hora)}
                        >
                          {hora}
                        </button>
                      ))}
                    </div>
                  )}
                  {_hayHorasMuyCercanas && (
                    <p className="fecha-aviso">
                      ¿Necesitás un horario más cercano? Se puede coordinar por WhatsApp con un costo adicional
                      por reservar con menos de 24 horas de anticipación.{" "}
                      <button type="button" className="link-whatsapp" onClick={abrirWhatsAppTurnoEspecial}>
                        Escribir por WhatsApp
                      </button>
                    </p>
                  )}
                </div>
              )
            )}

            <div className="reserva-navegacion">
              <button className="btn-secundario" onClick={() => setPaso(paso - 1)}>
                ← Atras
              </button>
              <button
                className="btn-principal"
                disabled={!fechaSeleccionada || !horaSeleccionada}
                onClick={() => setPaso(paso + 1)}
              >
                Siguiente →
              </button>
            </div>
          </div>
        )}

        {_pasoActual === "confirmacion" && (
          <div className="reservas-paso">
            <h2 className="paso-titulo">Confirma tu turno</h2>

            <div className="resumen-turno">
              <div className="resumen-item">
                <span className="resumen-label">Servicio</span>
                <span className="resumen-valor">
                  {nombreCompletoServicio(varianteSeleccionada)}
                </span>
              </div>
              <div className="resumen-item">
                <span className="resumen-label">Fecha</span>
                <span className="resumen-valor">{fechaSeleccionada}</span>
              </div>
              <div className="resumen-item">
                <span className="resumen-label">Hora</span>
                <span className="resumen-valor">{horaSeleccionada}</span>
              </div>
              <div className="resumen-item">
                <span className="resumen-label">Precio desde</span>
                <span className="resumen-valor resumen-precio">
                  ${varianteSeleccionada?.precio}
                </span>
              </div>
            </div>

            <p className="precio-nota">
              * Precio orientativo: el valor final se confirma en el estudio según los agregados o detalles extra que sumes el día del turno.
            </p>

            <div className="politica-cancelacion">
              <strong>Politica de cancelacion:</strong> podes cancelar tu turno sin costo
              hasta 48 horas antes. Pasado ese plazo, te pedimos avisar por WhatsApp.
            </div>

            <div className="formulario-grupo">
              <label className="formulario-label">Notas adicionales (opcional)</label>
              <textarea
                className="formulario-input formulario-textarea"
                placeholder="Algun detalle especial, alergia, preferencia..."
                value={notas}
                onChange={(e) => setNotas(e.target.value)}
                rows={3}
              />
            </div>

            <div className="reserva-navegacion">
              <button className="btn-secundario" onClick={() => setPaso(paso - 1)}>
                ← Atras
              </button>
              <button
                className="btn-rosa"
                disabled={cargando}
                onClick={confirmarReserva}
              >
                {cargando ? "Reservando..." : "Confirmar turno ✦"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Reservas;